module.exports = __webpack_public_path__ + "static/media/credit-white.83a56d1b.svg";